<template>
    <Dashboard />
</template>

<script>
import Dashboard from './Dashboard'

export default {
    components: {
        Dashboard
    }
}
</script>